<template>
	<div>
		<div class="con hidden-xs-only">
			<div class="bk">
				<div class="bk_left">
					<div class="iconCon">
						<div><i class="el-icon-phone-outline"></i></div>
						<div class="info">0510-86882258</div>
					</div>
					<div class="lineCon">
						<div></div>
					</div>
					<div class="iconCon">
						<div><i class="el-icon-message"></i></div>
						<div class="info">info@ssjt.cn</div>
					</div>
					<div class="lineCon">
						<div></div>
					</div>
					<div class="iconCon">
						<div><i class="el-icon-basketball"></i></div>
						<div class="info">www.ssjt.cn</div>
					</div>
				</div>
				<div class="bk_right"></div>
			</div>
			<div class="comp">
				<div class="up">江阴市尚时工程装备有限公司</div>
				<div class="down">Jiangyin Shangshi Engineering Equipment Co.,Ltd.</div>
			</div>
		</div>

		<div class="con hidden-sm-and-up">
			<div class="comp">
				<div class="up">江阴市尚时工程装备有限公司</div>
				<div class="down">Jiangyin Shangshi Engineering Equipment Co.,Ltd.</div>
			</div>
			<div class="bk">
				<div class="iconCon">
					<div><i class="el-icon-phone-outline"></i></div>
					<div class="info">0510-86882258</div>
				</div>
				<div class="lineCon">
					<div></div>
				</div>
				<div class="iconCon">
					<div><i class="el-icon-message"></i></div>
					<div class="info">info@ssjt.cn</div>
				</div>
				<div class="lineCon">
					<div></div>
				</div>
				<div class="iconCon">
					<div><i class="el-icon-basketball"></i></div>
					<div class="info">www.ssjt.cn</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Footer"
}
</script>

<style scoped>
	@media (max-width: 767px){
		.con{ background: #0d6eb2; width: 100%; height: 274px; }
		.comp{ text-align: center; color: #ffffff; padding-top: 70px; }
		.comp .up{ font-size: 22px; }
		.comp .down{ font-size: 12px; }
		.bk{ display: flex; justify-content: space-between; width: 80%; margin: 50px auto; }
		.lineCon{ padding: 5px 0; }
		.lineCon>div{ border-left: #ffffff 1px solid; height: 95%; }
		.iconCon{ color: #ffffff; text-align: center; }
		.iconCon i{ font-size: 25px; }
		.iconCon .info{ font-size: 12px; margin-top: 5px; }
	}
	@media (min-width: 768px){
		.con{ display: flex;justify-content: space-between; width: 100%; height: 274px; border-bottom: rgba(13, 110, 178, 0.1) 5px solid; }
		.bk{ display: flex; }
		.bk_left{ background: #0d6eb2; width: 473px; height: 274px; display: flex;}
		.lineCon{ padding: 180px 0 37px 37px; }
		.lineCon>div{ border-left: #ffffff 1px solid; height: 80%; }
		.iconCon{ color: #ffffff; text-align: center; padding: 175px 0 0 37px; }
		.iconCon i{ font-size: 35px; }
		.iconCon .info{ font-size: 12px; margin-top: 5px; }
		.bk_right{ background: url("../../assets/gczb/img/foot_right.png") left no-repeat; width: 295px; height: 274px; }
		.comp{ text-align: center; padding: 190px 70px 0 0; color: #425066; }
		.comp .up{ font-size: 24px; }
		.comp .down{ font-size: 12px; }
	}
</style>